/**
 * @description: 工单管理 => 录单form
 * @author
 */
<template>
  <div class="record-sheet-form">
    <!-- 炫米 -->
    <mi-softphone ref="miSoft" v-if="!noPhoneBar && softPhoneObj.seatExtensionNumber &&softPhoneObj.telephoneType===2 " :extno="softPhoneObj.seatExtensionNumber"
     @changeWaybill="changeWaybill"
      @changePhone="changePhone"
      @talkEnd="talkEnd"></mi-softphone>
      <!-- 声通 -->
    <jms-softphone ref="soft" v-if="!noPhoneBar && softPhoneObj.seatExtensionNumber&& softPhoneObj.telephoneType===1 " @talkEnd="talkEnd" @changeWaybill="changeWaybill" @changePhone="changePhone"
      style="margin-bottom: 12px;" :extno="softPhoneObj.seatExtensionNumber" :queue="softPhoneObj.stSkillGroup">
    </jms-softphone>
    <service-form
      :option="option"
      v-model="formData"
      ref="form"
      @submit="saveSubmit"
      @beforeSubmit="beforeSubmit"
      :loading="loading"
      class="bs-service leftform-customer-type"
    >
      <!-- 在运单号后面的按钮icon -->
      <template slot="waybillNoTipTwo">
        <!-- 网点信息 -->
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
          >
            <div
              slot="content"
              class="detail-tip-view"
            >
              <div>{{$lang('异常类型')}}: {{customerExcList.abnormalTypeName}}</div>
              <div>{{$lang('问题描述')}}: {{customerExcList.abnormalCauses}}</div>
              <template>
                <div>{{$lang('应对话术')}}: {{customerExcList.speechcraft}}</div>
                <div>{{$lang('解决方案')}}: {{customerExcList.solution}}</div>
                <div
                  style="text-align: center"
                >
                </div>
              </template>
            </div>
                <el-button
                  v-show="this.formData.waybillNo && !isEmptyObj(customerExcList) && customerExcList.abnormalTypeName"
                  class="customer-type"
                  type="primary"
                  >{{(customerExcList.abnormalTypeName || '').substring(0,5)}}</el-button>
          </el-tooltip>
      </template>

      <!-- 在运单号后面的icon -->
      <template slot="waybillNoTip">
        <!-- 网点信息 -->
          <abnomal-tip ref="abnomalTip" :waybillNo="this.formData.waybillNo"/>
      </template>
      <template slot="customerPhone">
        <el-row>
          <el-col :span="9">
            <el-input
              placeholder="请输入内容"
              v-model="formData.customerPhone"
              :disabled="isReminder"
              @input="changeInputPhone"
              class="input-with-select"
              maxlength="15"
              @blur="clearCustomerPhone"
            />
            <span
              type="text"
              class="search-btn"
              @click="searchFn"
            >{{$lang('查询')}}</span>
          </el-col>
          <el-col :span="2">
            <span v-if="softPhoneObj.telephoneType===1 ">
            <el-tooltip :content="$lang('来电次数')" :placement="'top'" v-show="!(customerNum === '')">
              <span class="customer-num">{{ customerNum }}</span>
            </el-tooltip>
            </span>
          </el-col>
          <el-col :span="13">
            <span v-if="customerTagList.length && formData.customerPhone">
              <el-tag  type="danger" size="mini" v-for="(item,index) in customerTagList" :key="index" style="margin-right:4px">{{item}}</el-tag>
            </span>
          </el-col>
        </el-row>
      </template>

      <template slot="customerSex">
        <el-radio-group
          v-model="formData.customerSex"
          @change="changeGender"
          class="radio-view customer-type-radio"
        >
          <el-radio :label="1">{{$lang('先生')}}</el-radio>
          <el-radio :label="2">{{$lang('女士')}}</el-radio>
        </el-radio-group>
      </template>
      <template slot="customerType">
        <el-radio-group
          v-model="formData.customerType"
          :disabled="isReminder"
          class="radio-view customer-type-radio"
          @input="customerTypeInput"
        >
          <el-radio :label="1">{{$lang('寄件人')}}</el-radio>
          <el-radio :label="2">{{$lang('收件人')}}</el-radio>
          <el-radio :label="3">{{$lang('其他')}}</el-radio>
        </el-radio-group>
      </template>
      <!-- 客户地址 -->
      <template slot="typeReceiverProvinceName">
        <address-select v-model="typeReceiver" :disabled="isUpgrade" @changeValue="typeReceiverAddressHandler" />
      </template>
      <template slot="receiverAreaId">
        <address-select
          v-model="addressInitData"
          :disabled="(isUpgrade || isDisabledAddress) && !formData.isProject"
          @changeValue="changeAddress"
        />
      </template>
       <!-- 客户地址 -->
      <template slot="address">
        <address-select v-model="customerAddressData" :disabled="!ifTransferOrder" @changeValue="customerAddressHandler" />
      </template>
      <template slot="firstType">
        <first-type-select
          v-model="formData.firstType"
          :list="firstTypeList"
          :isDisabledAll="isUpgrade"
          @change="changeFirstType"
        />
      </template>
      <template slot="secondTypeId">
        <div>
          <first-type-select
            v-model="formData.secondTypeId"
            :list="secondTypeList"
            :isDisabledAll="isUpgrade"
            @change="changeSecondType(formData.secondTypeId , true)"
          />
        </div>
      </template>
      <template slot="orderForm">
        <order-info-form
          ref="orderInfoForm"
          v-show="isPlaceOrder"
        />
      </template>
      <!-- <template slot="emergencyLevel">
        <el-radio-group
          v-model="formData.emergencyLevel"
          class="radio-view"
        >
          <el-radio
            v-for="item in emergencyCict"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio>
        </el-radio-group>
      </template> -->
      <template slot="memberType">
        <el-radio-group v-model="formData.memberType" class="radio-view" disabled>
          <el-radio v-for="item in memberTypeDict" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </template>
      <template slot="handlingOpinions">
        <!-- 当状态为关闭、暂不处理、催单时才展示工单话术 -->
        <div
          v-if="questionList.length && (formData.processingMode === 1 || formData.reminderMode === 2 || formData.reminderMode === 1)"
          class="project-process-question"
        >
          <div
            class="q-list"
            @click="selectQuestion(item.id)"
            :class="item.isChecked ? 'active' : ''"
            v-for="item in questionList"
            :key="item.id"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.scene"
              placement="top"
            >
              <span>{{item.scene}}</span>
            </el-tooltip>
            <i
              class="el-icon-success"
              v-if="item.isChecked"
            ></i>
          </div>
        </div>
        <div class="area">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="formData.handlingOpinions"
            maxlength="500"
            :rows="4"
            show-word-limit
            @input="changeOpinion"
          ></el-input>
        </div>
      </template>
      <template
        slot="mode"
        v-if="restartOrder"
      >
        <el-radio-group v-model="formData.processingMode" @input="changeProcessingMode">
          <el-radio :label="1">{{$lang('关闭')}}</el-radio>
          <el-radio
            :disabled="modeDisabled || defaultGroup === 1"
            :label="2"
          >{{$lang('重启工单')}}</el-radio>
        </el-radio-group>
      </template>
      <template
        slot="mode"
        v-else
      >
        <el-radio-group
          v-model="formData.processingMode"
          v-if="[1,2,3,4,5,9].includes(defaultGroup)"
          @input="changeProcessingMode"
        >
          <el-radio :label="1">{{$lang('关闭')}}</el-radio>
          <el-radio
            :label="2"
            :disabled="modeDisabled || defaultGroup === 1"
          >{{$lang('转单')}}</el-radio>
        </el-radio-group>
        <el-radio-group
          v-model="formData.reminderMode"
          v-if="[6,7,8].includes(defaultGroup)"
        >
          <el-radio :label="reminderModeMap.NOT_HANDLE">{{$lang('暂不处理')}}</el-radio>
          <el-radio :label="reminderModeMap.REMINDER">{{$lang('催单')}}</el-radio>
          <el-radio
            :label="reminderModeMap.UPGRADE"
            v-if="defaultGroup === 8"
          >{{$lang('升级')}}</el-radio>
        </el-radio-group>
      </template>
      <template
        slot="groupType"
        v-if="formData.processingMode === 2"
      >
        <el-radio-group
          v-model="formData.groupType"
          @change="handleChangeGroupType"
        >
          <el-radio
            :label="1"
            :disabled="isHqVip"
          >{{$lang('网点组')}}</el-radio>
          <el-radio
            :label="2"
            :disabled="isHqVip"
          >{{$lang('代理组')}}</el-radio>
          <el-radio
            :label="3"
            :disabled="!isHQ || isHqVip || formData.secondTypeCode === '2012'"
          >{{$lang('总部组')}}</el-radio>
          <el-radio
            :label="4"
            :disabled="!isHQ || formData.memberType === 2"
            v-if="hqVip"
          >{{ $lang('总部VIP组') }}</el-radio>
        </el-radio-group>
        <br v-if="formData.groupType === 3" />
        <el-radio-group
          v-model="formData.centerGroupType"
          v-if="formData.groupType === 3"
          class="line-radio"
        >
          <el-radio
            :label="1"
          >{{$lang('总部工单组')}}</el-radio>
          <el-radio
            :label="2"
          >{{$lang('总部理赔组')}}</el-radio>
          <!-- <el-radio
            :label="3"
            v-if="defaultGroup === 9"
          >{{ $lang('新JT工单组') }}</el-radio> -->
        </el-radio-group>
      </template>
      <template slot="networkId">
        <el-select
          v-if="[1,2,3,4,5,9].includes(defaultGroup) && formData.processingMode !== 1"
          style="width: 200px;"
          v-model="formData.networkId"
          @change="changeNetwork"
          filterable
          clearable
          :placeholder="$lang('请选择网点')"
        >
          <el-option
            v-for="item in networkOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-else-if="defaultGroup === 8"
          disabled
          :value="upgradeNetwork"
        />
      </template>
      <template slot="menuFormFront">
        <el-button
          @click="ResendPickupCode"
          :disabled="!isDisabledResend"
          type="primary"
          v-if="hasPower('SENDPICKCODE')"
        >{{
          $lang('重发取件码')
        }}</el-button>
        <el-button
          v-if="$route.name === 'callCenter'"
          type="primary"
          @click="$refs.sendSMSDialog.visible = true"
        >{{$lang('发送短信')}}</el-button>
        <el-button @click="resetFn">{{$lang('清空')}}</el-button>
      </template>
      <LabelInputField
        ref="labelField"
        v-if="!isUpgrade"
        key="problemDescription"
        slot="problemDescription"
        isRequired
        :list="descriptionList"
        :showUrgentLabel="formData.showUrgentLabel"
        :urgentOrderFlag="formData.urgentOrderFlag"
        @update:urgent="(val) => formData.urgentOrderFlag = val"
        @labelHTML="(val) => (formData.problemDescription = val)"
        @labelCount="(val) => (formData.labelList = val)"
      />
    </service-form>

    <waybill-dialog
      ref="waybillDialog"
      @selectWaybill="selectWaybill"
    ></waybill-dialog>
    <!-- 发送短信 -->
    <send-sms-dialog-new
      ref="sendSMSDialog"
      :type="1"
      :callBackPhone="formData.callBackPhone"
      :waybillNo="formData.waybillNo"
      :firstProblemTypeCode="formData.firstTypeCode"
      :showData="formData"
    />
  </div>
</template>

<script>
import WaybillDialog from './WaybillDialog'
import OrderInfoForm from './OrderInfoForm'
import JmsSoftphone from '@/components/NewSoftphone.vue'
import MiSoftphone from '@/components/MiSoftphone.vue'
// import JmsSoftphone from '@components/jms-widget/softphone/softphone.vue'
import { RULES } from '@/common/utils/validators'
import { RecordSheet } from './pool'
import { debounce } from '@public/utils/common'
import { RESPONSE_CODE } from '@public/http/config'
import mixin from '@mixins/mixin'
import { DICT } from '@/common/utils/dict'
import { PRODADDRESS } from '@/common/config/index'
import * as CONST_TYPE from '@public/utils/const'
import { mapGetters } from 'vuex';
import { isEmptyObj } from '@/common/utils/tool'
import AbnomalTip from '@/components/record/AbnormalTip'
import validateMsgMixin from '@/common/mixin/validateMsgMixin'

const REMINDER_MODE_MAP = {
  NOT_HANDLE: 1, // 暂不处理
  REMINDER: 2, // 催单
  UPGRADE: 3 // 升级
}

const getOriginForm = () => ({
  waybillNo: '',
  customerPhone: '',
  customerName: '',
  userName: '',
  userCode: '',
  customerCode: '',
  customerSex: 1,
  customerType: '',
  receiverAreaId: '',
  receiverDetailedAddress: '',
  firstType: '',
  firstTypeId: '',
  firstTypeName: '',
  secondTypeId: '',
  secondTypeName: '',
  secondTypeCode: '',
  processingMode: 1, // 关闭 / 转单
  reminderMode: 0, // 不处理 / 催单 / 升级
  groupType: 1,
  centerGroupType: 1,
  // emergencyLevel: 2,
  memberType: 2,
  networkId: '',
  reminderReason: '',
  problemDescription: '',
  callBackName: '',
  callBackPhone: '',
  handlingOpinions: '',
  isProject: '',
  bsType: false, // 接口返回百世物流轨迹状态
  orderId: '',
  soundRecordId: '',
  hqVip: false, // 是否为总部vip
  typeReceiverProvinceName: '',
  typeReceiverProvinceId: '',
  typeReceiverCityName: '',
  typeReceiverCityId: '',
  typeReceiverAreaName: '',
  typeReceiverAreaId: '',
  typeReceiverDetailedAddress: '',
  labelList: [],
  showUrgentLabel: false, // 是否显示加急
  urgentOrderFlag: 2 // 是否加急
})

export default {
  name: 'LeftForm',
  mixins: [mixin, validateMsgMixin],
  components: {
    WaybillDialog,
    OrderInfoForm,
    JmsSoftphone,
    MiSoftphone,
    AbnomalTip
  },
  props: {
    noPhoneBar: {
      type: Boolean,
      default: false
    },
    // 在线客服
    isService: {
      type: Boolean,
      default: false
    },
    // 页面判断日志操作
    channel: {
      type: String,
      default: '1'
    },
    // 面单发放网点
    pickUpNetworkName: {
      type: String,
      default: ''
    },
    customerInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      addressInitData: {},
      customerAddressData: {},
      typeReceiver: {},
      addressReqNetwork: null, // 无单转单,转单类型
      // 催单理由
      reasonOptions: DICT.urgeReason,
      transferOrderOwner: '',
      // 运单字段是否需要展示
      waybillVisible: false,
      // 运单是否已存在
      waybillExist: false,
      loading: false,
      secondTypeLoading: false,
      restartOrder: false, // 重启工单状态
      COM_HTTP: RecordSheet,
      isShowFirst: false,
      defaultGroup: 1,
      formData: getOriginForm(),
      firstTypeList: [],
      secondTypeList: [],
      keywordList: [],
      networkGroup: [],
      // 转单责任网点
      transferNetwork: {},
      // 默认网点
      defaultNetwork: {},
      softPhoneObj: {},
      upgradeNetwork: '',
      types: [],
      timer: null,
      emergencyCict: [
        {
          label: '一般',
          value: 2
        },
        {
          label: '紧急',
          value: 1
        }
      ],
      memberTypeDict: [
        {
          label: '会员',
          value: 1
        },
        {
          label: '非会员',
          value: 2
        }
      ],
      memberType: 2, // 会员标识，用于重置
      screenWidth: 0,
      allNetwork: {},
      customerNum: '',
      isProblemType: 2, // 是否是问题件,默认否
      questionList: [], // 工单话术
      descriptionList: [], // 问题描述工单话术
      immortalTrailList: [], // 百世物流轨迹
      reminderModeMap: REMINDER_MODE_MAP,
      orderSourceName: '', // 运单号来源
      storageType: true,
      isAll: false,
      waybillType: false, // 运单号校验状态
      onState: false, // 声通电话接听状态
      sensePhone: '', // 存储声通传递电话
      customerAddress: '', // 来电归属
      uuidOne: '',
      prescriptionData: {}, // 时效限制轨迹数据
      orderTip: '', // 订单提示
      cancelExplain: '', // 订单取消原因
      customerTagList: [],
      storageBasicInfo: {}, // 存储基础信息
      hqVip: false, // 是否为总部vip
      isOpinionChange: false, // 是否更改处理意见
      isChangeOpinions: false, // 是否更改了问题描述
      isConsolidation: false,
      customerExcList: {}, // 网点异常管理--异常信息--客户编号异常
      isEmptyObj: isEmptyObj,
      problemDescriptionStr: ''// 校验文字
    }
  },
  created() {
    // 单号输入防抖
    this.debounceFn = debounce(this.checkWaybillExist, 500)
    this.debounceOrder = debounce(this.checkOrderExist, 500)
    // 手机号码获取运单号执行方法 防抖
    this.queryOrder = debounce(this.queryOrderPhone, 500)
    this.queryDataAddress = debounce(this.getDataAddress, 500) // 根据地址获取运单信息
    this.setScreenWidth()
    window.addEventListener('resize', this.setScreenWidth)

    // 父级做事件巴士
    this.$parent.$on('getIsAll', isAll => {
      this.isAll = isAll;
      this.getInfoByInput();
      this.getTraceDataList();
      this.getPrescription()
    })

    // this.$bus.$on('leftFormHandlingOpinions', handlingOpinions => {
    //   this.formData.handlingOpinions = handlingOpinions
    // })
    this.isService && this.requestIsHqVip()
  },
  destroyed() {
    window.removeEventListener('resize', this.setScreenWidth)
    this.$parent.$off('getIsAll')
  },
  watch: {
    'imStorage.imUserList': {
      deep: true,
      immediate: true,
      handler(userList) {
        console.log('watch imStorage.imUserList change')
        // userList = ''
        if (userList && userList.length) {
          const obj = userList.find(item => item.isSelected) || {}
          console.log(JSON.stringify(obj))
          // im传递字段customerLevel：1 普通用户，2 vip用户
          setTimeout(() => {
            this.formData.memberType = this.memberType = `${obj.customerLevel}` === '2' ? 1 : 2
          })
        }
      }
    },
    // 处理模式禁用时不能选转单
    modeDisabled(newVal) {
      if (newVal) {
        this.formData.processingMode = 1
      }
    },
    // isDisabledAddress(val) {
    //   if (val) {
    //     this.addressInitData = {}
    //     this.formData.receiverDetailedAddress = ''
    //   }
    // },
    keywordList(list = []) {
      this.waybillExist = !!list.length
      this.$emit('trailList', list)
      this.getPrescription()
    },
    deep: true,
    addressInitData: {
      deep: true,
      handler(obj) {
        this.formData.receiverProvinceId = obj.provinceId
        this.formData.receiverProvinceName = obj.provinceName
        this.formData.receiverCityId = obj.cityId
        this.formData.receiverCityName = obj.cityName
        this.formData.receiverAreaId = obj.areaId
        this.formData.receiverAreaName = obj.areaName
      }
    },
    '$route.name': {
      handler(name) {
        // 切换回来页面 并且有缓存数据，调回传方法
        if (name === 'callCenter' && this.callbackWaybill) {
          this.changeWaybill(this.callbackWaybill)
          this.callbackWaybill = ''
        }
        // 在线客服 返回当前页再请求一级列表
        if ((name === 'imOnline' || name === 'callCenter' || name === 'imService') && this.firstTypeList.length === 0) {
          this.getFirstType()
        }
      },
      immediate: true
    },
    pickUpNetworkName(val) {
      this.$refs['form'].validateField('waybillNo')
    },
    customerInfo: {
      handler() {
        this.setRecordingCustomerPhone(this.customerInfo.customerPhone)
      },
      deep: true
    }
  },
  methods: {
    changeProcessingMode() {
      if (this.formData.processingMode === 2) {
        this.judgmentVip() // 触发组别change事件
      }
    },
    clearCustomerPhone() {
      if (!this.formData.customerPhone) {
        this.customerAddress = ''
        this.customerTagList = []
      }
    },
    /**
     *  重发取件码
     * waybillNo：true --运单号存在
     * waybillExist：true --运单号正确
     * keywordList：length --数据列表不为空
     */
    ResendPickupCode() {
      console.log(this.formData.waybillNo, '==' + this.waybillExist, this.keywordList.length);
      try {
        if (this.formData.waybillNo && this.waybillExist && this.keywordList.length !== 0) {
          RecordSheet.ResendPickupCode(this.formData.waybillNo)
          this.$message.success(this.$lang('重发取件码请求已提交'))
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 选中常用话术
    selectQuestion(id) {
      for (const item of this.questionList) {
        item.isChecked = item.id === id
        if (item.id === id) this.formData.handlingOpinions = item.fastWord
      }
    },
    // 获取工单话术列表
    async getfastWordsList() {
      // typeId: this.formData.secondTypeId
      if (!this.isOpinionChange) {
        this.formData.handlingOpinions = ''
        this.formData.problemDescription = ''
        this.formData.labelList = []
        this.$refs.labelField?.write(this.formData.problemDescription || '')
      }
      this.questionList = []
      this.descriptionList = []
      const { code, data, msg } = await RecordSheet.getfastWordsList({ current: 1, size: 9999, secondTypeId: this.formData.secondTypeId })
      if (code === RESPONSE_CODE.SUCCESS) {
        this.questionList = data.records?.filter(item => item.labelPosition === 1) || []
        this.descriptionList = data.records?.filter(item => item.labelPosition === 2) || []
      } else {
        this.$message.error(msg)
      }
    },
    // 手机号回填
    setRecordingCustomerPhone(customerPhone) {
      const { sessionId } = this.customerInfo;
      this.isChangeReq = !customerPhone
      if (this.isChangeReq) {
        this.formData.customerPhone = ''
        this.formData.callBackPhone = ''
      }
      if (customerPhone) {
        RecordSheet.getPhoneDetail(sessionId).then(({ data = '' }) => {
          this.formData.customerPhone = data
          this.formData.callBackPhone = data
        })
      }
    },
    // 回填信息
    getBillDetal(userCode, waybillCode, mobilePhone, receiverName, type) {
      this.storageType = true
      // 是否是会员
      if (!waybillCode && !mobilePhone && !receiverName) return
      let code = waybillCode || this.formData.waybillNo
      let phone = mobilePhone || this.formData.customerPhone
      let name = receiverName || this.formData.customerName
      if (type) {
        code = waybillCode
        phone = mobilePhone
        name = receiverName
      }
      debounce(this.checkWaybillExist(code), 500)
      this.formData.customerCode = userCode
      // 运单号
      // this.formData.waybillNo = code
      // 来电号码
      this.formData.customerPhone = phone
      // 来访对象
      this.formData.customerName = name
      // 回电号码
      this.changeCustomerPhone(phone)
      // 回电对象
      if (name) {
        const sex = this.formData.customerSex === 1 ? '先生' : '女士'
        this.formData.callBackName = name + sex
        this.$refs.form.validateField('callBackName')
      }
    },
    // 性别更改需要更改回电对象
    changeGender(val) {
      const { customerName, customerSex } = this.formData
      const sex = customerSex === 1 ? '先生' : '女士'
      if (customerName) {
        this.formData.callBackName = customerName + sex
      }
    },
    // 电话条回传运单号
    changeWaybill(num) {
      this.storageType = true
      if (num) {
        if (this.$route.name === 'callCenter') {
          this.formData.waybillNo = num
          this.checkWaybillExist(num)
        } else {
          // 不在当前页面缓存数据
          this.callbackWaybill = num
        }
      }
    },
    changePhone(num = '') {
      this.formData.customerPhone = num
      this.formData.callBackPhone = num
      if (num) {
        this.onState = true
        this.sensePhone = num
        // 重置国际件查询状态
        this.storageType = true
        this.getcustomerNum(num)
        this.phoneExp(num) && this.setTheLog('1')
      }
    },
    // 电话挂断触发
    talkEnd() {
      this.onState = false
      this.sensePhone = ''
    },
    getcustomerNum(num) {
      RecordSheet.getInfoByMobile({ mobile: num, waybillNo: this.formData.waybillNo }).then(res => {
        const { code, msg, data } = res
        if (code === RESPONSE_CODE.SUCCESS) {
          this.customerNum = data.callTimes
          // 运单号(不传会根据手机号反查最新运单号，传了则返回原值)
          this.formData.waybillNo = data.waybillNo
          this.checkWaybillExist(data.waybillNo)
          return
        }
        this.$message.error(msg)
      })
    },
    changeInputPhone(value) {
      // 当回电号码未改变过时要把值写入回电号码
      if (value) {
        value = value.replace(/\D/g, '')
        this.formData.customerPhone = value
        this.formData.callBackPhone = value
        this.$refs.form.validateField('customerPhone')
        this.$refs.form.validateField('callBackPhone')
        this.customerNum = ''
        this.phoneExp(value) && this.setTheLog('2')
      }
    },
    changeCustomerPhone(value) {
      // 当回电号码未改变过时要把值写入回电号码
      value = (value || '').replace(/\s/g, '')
      if (value) {
        this.formData.customerPhone = value
        this.formData.callBackPhone = value
        this.$refs.form.validateField('customerPhone')
        this.$refs.form.validateField('callBackPhone')
      }
    },
    // 获取一级类型
    getFirstType() {
      this.COM_HTTP.getFirstInputType().then(({ code, data, msg }) => {
        if (code === RESPONSE_CODE.SUCCESS) {
          this.firstTypeList = data.sort((o, n) => new Date(o.createTime).getTime() - new Date(n.createTime).getTime())
            ?.filter(o => o.code !== '11') // 隐藏极速理赔
          // 【总部客服组|888889】 【总部客服组02|888887】【总部客服组03|888885】
          const filterList = ['888889', '888887', '888885']
          const { networkCode } = this.user
          this.firstTypeList = this.firstTypeList?.filter(o => {
            if ((o.code === '5' && this.isNet) || (o.code === '5' && this.isCenter)) {
              if (filterList.includes(networkCode)) return o
            } else {
              return o
            }
          })
          const select = this.firstTypeList.find(o => o.name === '催查件') || data?.find(o => o.code === '20') // 催查件
          this.formData.firstType = select.id // 默认勾选
          this.changeFirstType(select.id)
          return
        }
        this.$message.error(msg)
      })
    },
    handleChangeGroupType() {
      this.formData.networkId = ''
      if (!this.networkOptions.find(o => o.id === this.formData.networkId) && this.networkOptions[0]) {
        this.formData.networkId = this.networkOptions[0].id
      }
      this.changeNetwork(this.formData.networkId)
    },
    // 获取物流轨迹网点
    async getNetworkList() {
      this.allNetwork = {}
      this.changeNetwork()
      const netList = this.keywordList?.filter(item => {
        return item.scanNetworkCode && item.isEntrepot !== 1 && item.isRetrogression !== 1
      }).map(o => o.scanNetworkCode)
      netList.push('0') // 确保不为空

      const firstPOD = this.keywordList[0] || {}
      if (firstPOD.nextNetworkCode && !(['到件扫描', '集货到件', '中心到件'].includes(firstPOD.scanTypeName))) {
        firstPOD.nextSiteIsEntrepot !== 1 && netList.unshift(firstPOD.nextNetworkCode)
      }
    },
    // 回填运单信息
    setWaybill(item) {
      this.waybillExist = !!this.keywordList.length
      console.log(item)
      if (!item || !item.waybillNo) return
      this.waybillExist = true
      const { receiverDetailedAddress, receiverProvinceName, receiverProvinceId, receiverCityId, receiverCityName, receiverAreaId, receiverAreaName, waybillNo } = item
      if (!this.isPlaceOrder) {
        this.formData.receiverDetailedAddress = receiverDetailedAddress
        if (!receiverProvinceId) {
          this.formData.receiverAreaId = '';
          this.addressInitData = {};
        } else if (!receiverCityId) {
          this.setAddressData(receiverProvinceId, receiverProvinceName, null, null, null, null);
        } else if (!receiverAreaId) {
          this.setAddressData(receiverProvinceId, receiverProvinceName, receiverCityId, receiverCityName, null, null);
        } else {
          this.formData.receiverAreaId = receiverAreaId;
          this.setAddressData(receiverProvinceId, receiverProvinceName, receiverCityId, receiverCityName, receiverAreaId, receiverAreaName);
        }
      }
      this.changeCustomerPhone(this.formData.customerPhone)
      Object.assign(this.formData, { waybillNo })
      setTimeout(() => {
        this.$refs.form.validateField('receiverAreaId')
      })
    },
    // 地址赋值
    setAddressData(provinceId, provinceName, cityId, cityName, areaId, areaName) {
      this.addressInitData = {
        provinceId: provinceId,
        provinceName: provinceName,
        cityId: cityId,
        cityName: cityName,
        areaId: areaId,
        areaName: areaName
      };
    },
    changeAddress(data) {
      Object.assign(this.formData, data)
      this.$refs.form.validateField('receiverAreaId')
    },
    validatorWaybill(rule, value, callback) {
      this.waybillType = false
      if (!value) return
      const reg = /^([JU]T|55)\d{13}$|^\d{13}$/
      if (!reg.test(value)) {
        callback(new Error(this.$lang('请输入正确的运单号')))
        return
      }
      // 不存在物流轨迹时判断有无面单发放网点
      if (value && !this.waybillExist && this.keywordList.length === 0 &&
        this.immortalTrailList.length === 0 && !this.pickUpNetworkName) {
        callback(new Error(this.$lang('不存在该面单')))
      }
      // if (value && !this.waybillExist && this.keywordList.length === 0 && this.immortalTrailList.length === 0) {
      //   callback(new Error(this.$lang('不存在该运单')))
      // }
      this.waybillType = true
      callback()
    },
    // 物流跟踪
    async getTraceDataList() {
      if (!this.formData.waybillNo) {
        return
      }
      const { code, data, msg } = await RecordSheet.traceDataList(this.formData.waybillNo, this.isAll)
      if (code !== RESPONSE_CODE.SUCCESS_COPY) {
        this.$message.warning(msg)
      }
      this.keywordList = []
      if (data && data[0] && data[0].details) {
        this.keywordList = data[0].details
      }
      this.$refs['form'].validateField('waybillNo')
      // 根据物流轨迹获取对应的网点
      this.getNetworkList()
    },
    // 查询回填
    selectWaybill({ waybillNo }) {
      waybillNo && this.checkWaybillExist(waybillNo)
    },
    // 请求百世单号轨迹信息
    async getImmortalTrail() {
      const { waybillNo } = this.formData
      if (!waybillNo || waybillNo.substr(0, 2) !== '55') {
        return
      }
      // 传递兄弟组件
      this.$bus.$emit('getBsTrack', { waybillNo, isBs: true })
      try {
        const { data, msg, code } = await RecordSheet.getQueryBs({ billCodes: [waybillNo] })
        if (code === RESPONSE_CODE.SUCCESS) {
          this.immortalTrailList = data || []
        } else {
          this.$message.error(msg)
        }
        this.$refs['form'].validateField('waybillNo')
      } catch (e) {
        console.log(e);
      }
    },
    // 检查运单是否存在并且获取运单详情及物流轨迹
    async checkWaybillExist(waybillNo = '') {
      this.networkGroup = []
      this.keywordList = []
      this.immortalTrailList = []
      this.addressInitData = {}
      this.formData.receiverDetailedAddress = ''
      if (waybillNo) {
        waybillNo = waybillNo.replace(/\s/g, '')
      } else {
        // 针对55录单
        this.formData.centerGroupType = 1
        this.defaultGroup = 1
        this.formData.processingMode = 1
        this.formData.reminderMode = 0
      }
      // 运单号开头是否是55
      if (waybillNo && this.storageType && !waybillNo.startsWith('55')) {
        this.storageType = false
        if (waybillNo.length < 2) return this.changeWaybillNo('', false)
        const str = waybillNo.substring(0, 2).toUpperCase()
        if (location.hostname === PRODADDRESS) {
          if (str === 'JT') {
            waybillNo = str + waybillNo.substring(2, waybillNo.length)
          } else {
            waybillNo = 'JT' + waybillNo
          }
        } else {
          if (str === 'UT' || str === 'JT') {
            waybillNo = str + waybillNo.substring(2, waybillNo.length)
          } else {
            waybillNo = 'UT' + waybillNo
          }
        }
      }
      // 发是否符合调接口的规则
      let succcess = false
      const reguat = /^[JU]T\d{13}|\d{13}|55[0-9]{13}$/ // 测试环境验证规则
      const reqprod = /^JT\d{13}|\d{13}|55[0-9]{13}$/ // 生产环境验证规则
      succcess = location.hostname === PRODADDRESS ? reqprod.test(waybillNo) : reguat.test(waybillNo)
      this.formData.waybillNo = waybillNo
      this.$refs.form.resetFields()
      if (waybillNo && succcess) {
        await this.$refs.abnomalTip.getNetWaybill(waybillNo)
        await this.getConsolidation(waybillNo)
        // 异常客服编号提示
        await this.getCustomerExc(waybillNo)
        await this.getDefaultByType()
        await this.getTraceDataList()
        // 获取bs物流轨迹
        await this.getImmortalTrail()
        this.getWaybillDetail()
      } else {
        this.setWaybill()
        this.keywordList = []
        this.formData.reminderMode = 0
        this.formData.processingMode = 1
        this.changeNetwork()
      }
      this.changeWaybillNo(waybillNo, succcess)
    },
    // 设置运单号来源
    // async getRepository(Waybill) {
    //   try {
    //     const { data } = await this.COM_HTTP.reqRepository(Waybill)
    //     data && (this.orderSourceName = data.orderSourceName)
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    /**
     * 客户地址
     */
    typeReceiverAddressHandler(data) {
      const { areaName = '', cityName = '', provinceName = '', areaId = '', cityId = '', provinceId = '' } = data
      this.formData = {
        ...this.formData,
        typeReceiverProvinceName: provinceName,
        typeReceiverProvinceId: provinceId,
        typeReceiverCityName: cityName,
        typeReceiverCityId: cityId,
        typeReceiverAreaName: areaName,
        typeReceiverAreaId: areaId
      }
      this.queryDataAddress('typeReceiver')
    },
    // 设置来电归属地
    async getCustomerAddress(phone) {
      try {
        const { data } = await this.COM_HTTP.reqCustomerAddress(phone)
        data && (this.customerAddress = data.province && `${data.province}   ${data.city}`)
      } catch (error) {
        console.log(error);
      }
    },
    // 获取标签
    async getQueryByPhone(phone) {
      try {
        const { data } = await this.COM_HTTP.queryByPhone(phone)
        if (data) {
          this.customerTagList = data
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 请求百世基础信息回填
     */
    async getBsWaybillDetail(waybill) {
      try {
        const { data, code, msg } = await RecordSheet.queryBillBs({ billCodes: [waybill] })
        if (code === RESPONSE_CODE.SUCCESS) {
          this.setWaybill(data && data[0] ? data[0] : {})
          this.formData.userCode = data.customerCode || ''
          this.formData.userName = data.customerName || ''
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeWaybillNo(waybillNo, succcess) {
      this.formData.waybillNo = waybillNo
      this.$refs.form.validateField('waybillNo')
      if (!succcess) waybillNo = ''
      this.storageBasicInfo = {}
      this.$emit('waybillNo', waybillNo)
    },
    changeFirstType(firstId, secondId) {
      this.formData.networkId = ''
      // 需设置code name id
      this.formData.firstTypeId = firstId
      const { code, name } = this.firstTypeList.find(item => item.id === firstId) || {}
      this.formData = {
        ...this.formData,
        secondTypeId: '',
        secondTypeCode: '',
        secondTypeName: '',
        firstTypeCode: code,
        firstTypeName: name
      }
      this.waybillVisible = false
      this.transferOrderOwner = ''
      this.secondTypeLoading = true
      this.secondTypeList = []
      this.COM_HTTP.getSecondType({
        id: firstId,
        waybillNo: this.formData.waybillNo
      }).then(({ code, data, msg }) => {
        this.secondTypeLoading = false
        if (code === RESPONSE_CODE.SUCCESS) {
          this.secondTypeList = data.secondListVOList || []
          // 时效限制轨迹数据
          const { currentDuration, estimateDuration, transportationStatus, isPrescription } = data || {}
          this.prescriptionData = { currentDuration, estimateDuration, transportationStatus, isPrescription }
          this.$emit('prescriptionData', this.prescriptionData)
          // 【总部客服组|888889】 【总部客服组02|888887】【总部客服组03|888885】
          const filterList = ['888889', '888887', '888885']
          const { networkCode } = this.user
          // 咨询：【信息更改】2003、【退回】2002”，
          // 网点类型为：网点（总部外包客服除外）、中心、加盟商层级，不显示该问题类型：
          // 外包客服code“【总部客服组|888889】，【总部客服组02|888887】，【总部客服组03|888885】
          this.secondTypeList = this.secondTypeList?.filter(o => {
            if (((o.code === '2002' || o.code === '2003') && this.isNet) || ((o.code === '2002' || o.code === '2003') && this.isCenter)) {
              if (filterList.includes(networkCode)) return o
            } else {
              return o
            }
          })
          // 集运仓件-禁用签收未收到
          this.secondTypeList = this.secondTypeList.map(o => {
            o.code === '2104' && this.formData.waybillNo && this.isConsolidation && (o.isDisabled = true)
            return o
          })
          // if (secondId) {
          //   this.changeSecondType(secondId)
          // } else {
          //   if (data && data[0]) {
          //     this.changeSecondType(data[0].id)
          //   }
          // }
          this.changeSecondType() // 二级类型
          return
        }
        this.$message.warning(msg)
      })
    },
    // 二级类型改变设置
    // 选择二级类型 (如果为下单，则需展示下单表单)
    async changeSecondType(id, type) {
      this.formData.networkId = ''
      this.formData.orderId = ''
      this.orderTip = ''
      let item = {}
      // 无单转单清空
      this.addressReqNetwork = null
      this.customerAddressData = {}
      this.formData.details = ''
      if (id) {
        item = this.secondTypeList.find(item => item.id === id) || {}
        const { code, name, reminderCount, treatmentLimitation, id: secondTypeId } = item
        this.formData.secondTypeId = secondTypeId
        this.formData.secondTypeCode = code
        this.formData.secondTypeName = name
        this.formData.secondTypeReminderCount = reminderCount
        this.formData.secondTypeTreatmentLimitation = treatmentLimitation
        this.transferOrderOwner = item.transferOrderOwner
        this.getfastWordsList()
        if (['2012', '2001'].includes(code)) {
          this.addressInitData = {}
          this.formData.receiverDetailedAddress = ''
        }
        if (name === '下单') {
          this.waybillVisible = true
          this.keywordList = []
          this.changeWaybillNo('')
          this.defaultGroup = 1
          this.formData.processingMode = 1
          this.formData.reminderMode = 0
          this.formData.bsType = false
          this.formData.centerGroupType = 1
          this.restartOrder = false
        } else {
          this.waybillVisible = false
        }
      }
      // 无单转单
      this.orderConversion()
      const { standardReply = '', problemRemark = '' } = item
      if (!this.isOpinionChange) {
        this.formData.handlingOpinions = standardReply
      }
      if (![REMINDER_MODE_MAP.REMINDER, REMINDER_MODE_MAP.UPGRADE].includes(this.formData.reminderMode) && !this.isChangeOpinions) {
        this.formData.labelList = []
        this.formData.problemDescription = problemRemark
      }
      console.log(this.formData);
      // 根据手机号码获取订单信息
      this.queryOrder()
      this.getInfoByInput(type)
    },
    // 无单转单
    orderConversion() {
      if (this.ifTransferOrder) {
        this.waybillVisible = true
        this.orderSourceName = ''
        this.storageType = true
        this.changeWaybillNo('')
      }
    },
    customerAddressHandler(data) {
      const { areaName = '', cityName = '', provinceName = '' } = data
      this.formData.addressName = provinceName + cityName + areaName
      this.formData.address = data?.cityId
      this.formData.details = ''
      this.customerAddressData.details = ''
      this.addressReqNetwork = null
      this.queryDataAddress()
    },
    /**
     * 根据地址获取运单信息
     */
    async getDataAddress(type) {
      const address = type === 'typeReceiver' ? this.typeReceiver : this.customerAddressData
      const { provinceId, cityId, areaId, details } = address
      if (!provinceId || !cityId || !areaId || !details) return
      const { data } = await RecordSheet.getInfoByAddress(address)
      this.handleInfo(data)
    },
    /**
     * 无单转单处理信息
     */
    handleInfo(data) {
      this.addressReqNetwork = data || null
      this.isProblemType = data?.isProblemType
      if (data?.workOrderDetail) {
        const { customerPhone, callBackPhone } = data.workOrderDetail
        this.formData = { ...this.formData, ...data.workOrderDetail, isProject: data.isProject, callBackPhone: callBackPhone || customerPhone }
        customerPhone && this.getCustomerAddress(customerPhone)
      }
      if (this.formData.waybillNo && this.keywordList.length !== 0 && this.isService) {
        this.getCheckStatus()
      }
      // 默认网点 defaultNetwork
      const { transferNetworkType, restartOrder, transferNetwork, defaultGroup, defaultNetwork, networkGroup, agentAreaNetwork } = data
      const dn = (this.defaultNetwork = defaultNetwork || {})
      // 默认组别 1:关闭 2:网点组 3:代理组 4:总部工单组 5:总部理赔组 6:暂不处理 7:催单 8:升级
      const dg = (this.defaultGroup = defaultGroup)
      this.networkGroup = networkGroup || []
      // 重启工单状态
      this.restartOrder = restartOrder
      // 默认转责任单网点
      this.transferNetwork = transferNetwork || ''
      // 重置状态
      this.formData = {
        ...this.formData,
        centerGroupType: 1,
        transferNetworkType: transferNetworkType,
        processingMode: 1,
        reminderMode: 0,
        groupType: 1,
        networkId: '' // 代理区信息(默认组别为升级时才有值)
      }
      const da = agentAreaNetwork || {}
      if (dg === 1) {
        this.formData.processingMode = 1
      } else if ([2, 3, 4, 5].includes(dg)) {
        this.formData.processingMode = 2
        if ([4, 5].includes(dg)) {
          this.formData.groupType = 3
          this.formData.centerGroupType = dg - 3
        } else {
          this.formData.groupType = dg - 1
        }
        this.changeNetwork(dn.id, true)
      } else if (dg === 7) {
        this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE
      } else if (dg === 8) {
        this.formData.groupType = 2
        this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE
        this.formData.networkId = da.id
      }
    },
    // 后台录单基础数据
    getInfoByInput(type) {
      this.formData.showUrgentLabel = false
      this.formData.urgentOrderFlag = 2
      const { waybillNo, firstTypeId, secondTypeId, orderId } = this.formData
      if (!(waybillNo || orderId) || !firstTypeId) {
        return
      }
      const historyType = this.isAll ? 2 : 1;
      let reqPool = 'getInfoByInput'
      const params = {
        firstTypeId,
        secondTypeId,
        historyType
      }
      // 是否是订单查询 置空运单号
      if (this.isRushTake) {
        this.formData.waybillNo = ''
        this.$emit('waybillNo', this.formData.waybillNo)
        this.$bus.$emit('getOrderId', this.formData.orderId)
        reqPool = 'getInfoByOrderId'
        params.orderId = orderId
        this.addressInitData = {}
        this.formData.receiverDetailedAddress = ''
      } else {
        params.waybillNo = waybillNo
        Object.assign(params, { waybillNo, historyType })
      }
      if (this.isRushTake && !orderId) return
      RecordSheet[reqPool](params).then(({ code, data, msg }) => {
        if (code === RESPONSE_CODE.SUCCESS) {
          this.isProblemType = data.isProblemType;
          if (data && data.workOrderDetail) {
            if (type) {
              delete data.workOrderDetail.secondTypeId
              delete data.workOrderDetail.secondTypeCode
              delete data.workOrderDetail.secondTypeName
            }
            this.formData = { ...this.formData, ...data.workOrderDetail, isProject: data.isProject } // TODO
            this.setCustomerPhone()
            data.workOrderDetail.waybillNo = this.formData.waybillNo
            this.formData.firstTypeId = firstTypeId
            this.setWaybill(data.workOrderDetail)
          }

          // 是否 有400 在线客服权限 且有物流轨迹
          // if (this.formData.waybillNo && (this.keywordList.length !== 0 || this.immortalTrailList.length !== 0) && (this.isService || !this.noPhoneBar)) {
          //   // 去请求存储记录
          //   this.getCheckStatus()
          // }
          if (this.formData.waybillNo && (this.keywordList.length !== 0 || this.immortalTrailList.length !== 0) && this.isService) {
            // 去请求存储记录
            this.getCheckStatus()
          }
          // if (this.formData.waybillNo && (this.keywordList.length !== 0 || this.immortalTrailList.length !== 0)) {
          //   this.getRepository(waybillNo)
          // }

          // 重置总部组状态 兼容bs
          this.formData.centerGroupType = 1
          this.formData.transferNetworkType = data.transferNetworkType;
          // 接口返回百世状态
          this.formData.bsType = data.isBs
          this.networkGroup = data.networkGroup
          // 默认转责任单网点
          this.transferNetwork = data.transferNetwork
          // 默认组别 1:关闭 2:网点组 3:代理组 4:总部工单组 5:总部理赔组 6:暂不处理 7:催单 8:升级
          const dg = data.defaultGroup
          // 重启工单状态
          this.restartOrder = data.restartOrder
          this.defaultGroup = dg
          this.formData.processingMode = 0
          this.formData.reminderMode = 0
          // 默认网点 defaultNetwork
          this.defaultNetwork = data.defaultNetwork || {}
          const dn = data.defaultNetwork || {}
          // 代理区信息(默认组别为升级时才有值)
          const da = data.agentAreaNetwork || {}
          // 加急工单
          this.formData.showUrgentLabel = data.showUrgentLabel || false
          this.formData.networkId = ''
          if (dg === 1) {
            this.formData.processingMode = 1
          } else if ([2, 3, 4, 5].includes(dg)) {
            this.formData.processingMode = 2
            if ([4, 5].includes(dg)) {
              this.formData.groupType = 3
              this.formData.centerGroupType = dg - 3
            } else {
              this.formData.groupType = dg - 1
            }
            this.changeNetwork(dn.id, true)
          } else if (dg === 7) {
            this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE
          } else if (dg === 8) {
            this.upgradeNetwork = da.name || ''
            this.formData.reminderMode = REMINDER_MODE_MAP.NOT_HANDLE
            this.formData.networkId = da.id
          } else if (dg === 9) {
            this.formData.processingMode = 2
            this.formData.groupType = 3
            this.formData.centerGroupType = 3
            this.changeNetwork(dn.id, true)
          }
          this.judgmentVip() // 触发组别change事件
          this.$nextTick(() => {
            this.$refs.form.validateField('customerPhone');
            if (!this.isUpgrade) {
              if (data.workOrderDetail && data.workOrderDetail.problemDescription) {
                this.formData.labelList = []
                this.$refs.labelField?.write(this.formData.problemDescription || '')
              } else if (!(this.formData.labelList && this.formData.labelList.length > 0)) {
                this.$refs.labelField?.write(this.formData.problemDescription || '')
              }
            }
          })
        }
      })
    },
    /**
     * 声通电话接听状态赋值操作
     */
    setCustomerPhone() {
      // 400来电 来电号码 展示当前来电号码
      if (this.onState) {
        this.formData.customerPhone = this.sensePhone
        this.formData.callBackPhone = this.sensePhone
      }
    },
    // 选择网点
    changeNetwork(val, isFirstLoad) {
      // 字符串容错
      val = val && (val - '')
      const { code = '', id = '', name = '', typeId = '' } = this.networkOptions.find(item => item.id === val) || {}
      console.log(code, id, name, typeId)
      this.formData.networkId = id
      this.formData.acceptNetworkCode = code
      this.formData.acceptNetworkId = id
      this.formData.acceptNetworkName = name
      this.formData.acceptNetworkTypeId = typeId
      // 转责任单网点
      if (this.defaultNetwork.code === code && this.defaultNetwork.id === id && this.defaultNetwork.name === name && this.defaultNetwork.typeId === typeId || isFirstLoad) {
        this.formData.transferNetworkId = this.transferNetwork.id
        this.formData.transferNetworkCode = this.transferNetwork.code
        this.formData.transferNetworkName = this.transferNetwork.name
        this.formData.transferNetworkTypeId = this.transferNetwork.typeId
      } else {
        this.formData.transferNetworkId = id
        this.formData.transferNetworkCode = code
        this.formData.transferNetworkName = name
        this.formData.transferNetworkTypeId = typeId
      }
      console.log('defaultNetwork', this.defaultNetwork, this.formData)
    },
    beforeSubmit() {
      if (this.formData.secondTypeName === '下单') {
        // 运行 验证
        this.$refs.orderInfoForm.submitForm()
      }
      this.handlingOpinionsMsg = ''// 校验文字置空
      this.problemDescriptionStr = ''// 问题描述校验置空
    },
    // 取缓存的号码和页面号码做对比，一致就新增来访记录
    async getUuidPhone() {
      const { customerPhone, waybillNo } = this.formData
      const { phone, uuid } = JSON.parse(localStorage.getItem('uuidObj')) || {}
      if (this.noPhoneBar || !customerPhone || !waybillNo || !phone) return
      if (customerPhone === phone) {
        this.formData.soundRecordId = uuid || ''
        await this.getStorages(1, uuid)
      } else {
        this.formData.soundRecordId = ''
      }
    },
    // 提交表单 (录单或催单)
    async saveSubmit() {
      // 重置国际件查询状态
      this.storageType = true
      this.loading = true
      const handlingOpinionsVaildate = await this.getHandlingOpinionsMsg(this.formData.handlingOpinions)
      const problemDescriptionVaildate = await this.getHandlingOpinionsMsg(this.formData.problemDescription, 'problemDescriptionStr')// 第二个入参为校验文字

      if (problemDescriptionVaildate || handlingOpinionsVaildate) {
        this.$refs.form.validateField('handlingOpinions')
        this.$refs.form.validateField('problemDescription')// 重新触发处理意见校验
        this.loading = false
        return
      }
      await this.getUuidPhone()
      // 自研平台录单获取对应会话数据
      const targetSession = this.$route.name === 'imService' && (this.imStorage.imUserList || []).find(item => item.isSelected)
      if (targetSession) {
        this.formData.sessionId = targetSession.sessionId
      }
      const iframes = document.getElementsByTagName('iframe')
      // 催单 / 升级
      if (this.isUpgrade) {
        const { reminderMode } = this.formData
        const keys = {
          '1': 2, // 暂不处理
          '2': 1, // 催单
          '3': 3 // 升级
        }
        this.formData.workOrderId = this.formData.id
        this.formData.type = keys[reminderMode]
        // if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 1) {
        //   this.formData.soundRecordId = this.$refs.soft.Call_ID
        // } else if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 2) {
        //   this.formData.soundRecordId = this.$refs.miSoft.uuid
        // } else {
        //   this.formData.soundRecordId = ''
        // }
        this.loading = true
        const params = { ...this.formData }
        delete params.showUrgentLabel
        this.COM_HTTP.reqReminder(params)
          .then(({ code, msg }) => {
            this.loading = false
            if (code === RESPONSE_CODE.SUCCESS) {
              this.resetFn()
              this.$message.success(msg)
              if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 1) {
                this.$refs.soft.setready() // 声通
              } else if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 2) {
                this.$refs.miSoft.setready() // 炫米
              }
              for (const ele of iframes) {
                ele?.contentWindow.postMessage(targetSession?.sessionId, '*')
              }
              return
            } else {
              this.$message.warning(msg)
            }
          })
          .catch(() => {
            this.loading = false
          })
        return
      }
      const reqData = {
        workOrder: {
          ...this.formData
        }
      }
      delete reqData.workOrder.showUrgentLabel
      if (this.formData.secondTypeName === '下单') {
        // 判断下单表格是否已校验完毕
        const res = await this.$refs.orderInfoForm.submitForm()
        if (!res) {
          return
        }
        // 下单需设置默认值
        reqData.order = {
          from: 12,
          paymentModeCode: 'PP_CASH',
          sendName: '上门取件',
          packageTotalWeight: 1,
          packageChargeWeight: 1,
          packageNumber: 1,
          // paidModeCode: '01',
          sendCode: '01',
          needDispatch: 1,
          signSmsNotify: 0,
          senderSmsNotify: 0,
          dispatchCode: '03',
          dispatchName: '派送上门',
          expressTypeCode: 'EZ',
          ...res
        }
        if (targetSession) {
          reqData.order.sessionId = targetSession.sessionId
        }
      }
      // 关闭 使用登陆网点
      if ([1, 2, 3, 4, 5].includes(this.defaultGroup) && this.formData.processingMode === 1) {
        const { networkId, networkCode, networkName, networkType } = this.user
        reqData.workOrder.acceptNetworkCode = networkCode
        reqData.workOrder.acceptNetworkId = networkId
        reqData.workOrder.acceptNetworkName = networkName
        reqData.workOrder.acceptNetworkTypeId = networkType
      }
      this.loading = true
      const group = {
        callCenter: 1,
        imOnline: 2,
        tiktokTable: 2,
        imService: 2
      }
      reqData.workOrder.recordGroup = group[this.$route.name]
      reqData.workOrder.historyType = this.isAll ? 2 : 1
      // 接口传值是否是bs
      reqData.workOrder.isBs = this.formData.bsType
      // if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 1) {
      //   reqData.workOrder.soundRecordId = this.$refs.soft.Call_ID
      // } else if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 2) {
      //   reqData.workOrder.soundRecordId = this.$refs.miSoft.uuid
      // } else {
      //   reqData.workOrder.soundRecordId = ''
      // }
      if (this.ifTransferOrder) {
        // 转单,处理意见拼上客户地址
        const { processingMode, handlingOpinions } = this.formData
        const str1 = `客户地址：${this.formData?.addressName}${this.customerAddressData.details}；`
        const str2 = processingMode === 1 ? handlingOpinions : ''
        reqData.workOrder.handlingOpinions = str1 + str2
      }
      this.COM_HTTP.reqSave(reqData)
        .then(({ code, msg }) => {
          this.loading = false
          if (code === RESPONSE_CODE.SUCCESS) {
            this.resetFn()
            this.$message.success(this.$lang('录单保存成功！'))
            // 电话条 工单提交,调用状态就绪方法
            if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 1) {
              this.$refs.soft.setready() // 声通
            } else if (!this.noPhoneBar && this.softPhoneObj.seatExtensionNumber && this.softPhoneObj.telephoneType === 2) {
              this.$refs.miSoft.setready() // 炫米
            }
            for (const ele of iframes) {
              ele?.contentWindow.postMessage(targetSession?.sessionId, '*')
            }
            return
          }
          this.$message.warning(msg)
        })
        .catch(() => {
          this.loading = false
        })
    },
    resetFn() {
      this.orderSourceName = '' // 运单号来源清空
      this.customerAddress = ''// 来电归属清空
      this.customerTagList = [] // 标签清空
      this.isOpinionChange = false
      this.isChangeOpinions = false
      this.$refs.form.resetForm()
      this.waybillVisible = false
      if (this.$refs.orderInfoForm && this.$refs.orderInfoForm.resetFields) {
        this.$refs.orderInfoForm.resetFields()
      }
      this.$nextTick(() => {
        this.defaultGroup = 1
        this.formData = getOriginForm()
        this.formData.memberType = this.memberType
        this.checkWaybillExist()
        this.$bus.$emit('getOrderId', '')
        this.addressInitData = {}
        this.$refs.labelField?.reset()
        setTimeout(() => {
          const select = this.firstTypeList.find(o => o.name === '催查件') || this.firstTypeList?.find(o => o.code === '20')
          this.formData.firstType = select.id
          this.changeFirstType(select.id)
          this.orderTip = '' // 订单提示
          this.cancelExplain = '' // 订单取消原因
        }, 100)
        this.keywordList = []
      })
    },
    searchFn() {
      const { customerPhone } = this.formData
      if (this.isUpgrade || this.formData.secondTypeName === '下单' || !/(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)/.test(customerPhone)) return
      if (customerPhone && (customerPhone + '').trim()) {
        this.$refs.waybillDialog.show(customerPhone)
      }
    },
    // 获取声通电话条配置
    getServiceStaff() {
      console.log(this.user)
      RecordSheet.reqServiceStaff({ code: this.user.code }).then(res => {
        // todo 连接电话条的分机号和声通技能组
        const { code, msg, data } = res
        if (code === RESPONSE_CODE.SUCCESS) {
          // if (!data) {
          //   this.$notify({
          //     title: this.$lang('提示'),
          //     message: this.$lang('当前账户未配置坐席号分机号,请去客服人员管理配置'),
          //     duration: 0,
          //     type: 'warning'
          //   })
          // }
          this.softPhoneObj = data || {}
          return
        }
        this.$message.warning(msg)
      })
    },
    setScreenWidth() {
      this.screenWidth = document.body.offsetWidth
    },
    async getDefaultByType() {
      RecordSheet.getDefaultByInput({ waybillNo: this.formData.waybillNo }).then(res => { // 还原类型
        const { code, msg, data } = res
        if (code === RESPONSE_CODE.SUCCESS) {
          const firstId = (data.defaultFirstType && data.defaultFirstType.id) || ''
          // const secondId = (data.defaultSecondType && data.defaultSecondType.id) || ''
          this.formData.firstType = firstId
          this.changeFirstType(firstId)
          return
        }
        this.$message.error(msg)
      })
    },
    /**
     * 获取当前会话状态 判断是否是通话接待状态
     */
    async getCheckStatus(num) {
      // 如果有400权限
      // 请求声通接口查询是否正在通话中
      // if (!this.noPhoneBar && this.onState && this.formData.customerPhone) {
      //   if (this.softPhoneObj.telephoneType === 1) {
      //     this.uuidOne = this.$refs.soft.Call_ID
      //   } else if (this.softPhoneObj.telephoneType === 2) {
      //     this.uuidOne = this.$refs.miSoft.uuid
      //   }
      //   this.getStorages(1, this.uuidOne)
      // } else
      if (this.isService && this.formData.customerCode) {
        // 如果有在线客服权限  // 请求在线客服状态是否在会话
        const { data, code, msg } = await RecordSheet.getSessionId({ waybillNo: this.formData.waybillNo, userCode: this.formData.customerCode })
        if (code === RESPONSE_CODE.SUCCESS) {
          data.sessionId && this.getStorages(2, data.sessionId)
        } else {
          this.$message.error(msg)
        }
      }
    },
    /**
     * 存储来电记录
     */
    async getStorages(type, id) {
      const { waybillNo, customerType, customerName, customerPhone } = this.formData
      const params = {
        waybillNo: waybillNo,
        callPhone: this.onState ? this.sensePhone : customerPhone, // 来电号码 判断是否是声通电话进来记录
        callPerson: customerName, // 来访对象
        callFrom: customerType, // 来电方
        callType: type, // 进线方式(1.热线电话 2.在线客服)
        sessionId: id // 在线客服取sessionId  400 取当前电话Call_ID / uuid
      }
      const { code, msg } = await RecordSheet.addCallRecord(params)
      if (code !== RESPONSE_CODE.SUCCESS) {
        this.$message.error(msg)
      }
    },
    /**
     * 记录来电回电手机号码日志
     * customerPhone 来电号码
     * callBackPhone 回电号码
     * waybillNo 运单号
     * callType 通话状态(1.通话中 2.未通话)
     * channel 渠道(1.jms录单页面 2.jms在线客服 3.外包呼叫中心 4.外包IM在线 5.抖音工作台)
     * inComingLineType 1.电话进线 2.来电号码更改 3.回电号码更改
     */
    async setTheLog(inComingLineType) {
      const { customerPhone, callBackPhone, waybillNo } = this.formData
      if (waybillNo) {
        const params = {
          customerPhone,
          callBackPhone,
          waybillNo,
          callType: this.onState ? '1' : '2',
          channel: this.channel,
          extensionNum: this.$refs.soft ? this.$refs.soft.extno : '',
          inComingLineType
        }
        const { code, msg } = await RecordSheet.phoneRecord(params)
        if (code !== RESPONSE_CODE.SUCCESS) {
          this.$message.error(msg)
        }
      }
    },
    /**
     * 手机号码校验
     */
    phoneExp(value) {
      const regExp = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)/
      const regExp2 = /^(\d)\1{5,14}$/
      return !(value && (!regExp.test(value) || regExp2.test(value)))
    },
    /**
     * 回电号码校验
     */
    callBackPhoneExp(value) {
      const regExp = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)|(^1[3-9]\d{13}$)/
      const regExp2 = /^(\d)\1{5,14}$/
      return !(value && (!regExp.test(value) || regExp2.test(value)))
    },
    callBackPhone(rule, value, callback) {
      const regExp = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)|(^1[3-9]\d{13}$)/
      const regExp2 = /^(\d)\1{5,14}$/
      const typeBs = this.formData.waybillNo && this.formData.waybillNo.startsWith('55')
      if (value && !typeBs && (!regExp.test(value) || regExp2.test(value))) {
        callback(new Error(this.$lang('请输入正确的回电号码')))
      }
    },
    // 订单规则校验
    orderExp(rule, value, callback) {
      const regExp = /^([0-9]{18,19})$/
      if (!regExp.test(value)) {
        callback(new Error(this.$lang('请输入正确的订单号')))
      } else {
        this.debounceOrder()
        callback()
      }
    },
    // 订单查询防抖
    checkOrderExist() {
      // 订单号验证完成去请求数据
      this.getInfoByInput()
      // 订单号请求基础信息
      this.getWaybillDetail()
    },
    // 请求运单/订单信息
    async getWaybillDetail() {
      try {
        const { waybillNo, orderId } = this.formData
        if (!waybillNo && !orderId) return
        let reqPool = 'getWaybillDetail'
        let params = waybillNo
        if (this.isRushTake) {
          reqPool = 'getOmsOrderById'
          params = orderId
          this.orderTip = ''
          this.cancelExplain = ''
        }
        const { data, code, msg } = await RecordSheet[reqPool](params)
        if (code === RESPONSE_CODE.SUCCESS) {
          // 基础信息为空时 走查询Bs基础信息  进行回填
          if (!data?.length && !this.isRushTake) return this.getBsWaybillDetail(waybillNo)
          let result = ''
          if (this.isRushTake) {
            result = data
            this.orderTip = result?.orderStatusName || ''
            this.cancelExplain = result?.cancelExplain || ''
          } else {
            result = data && data[0] ? data[0] : {}
          }
          this.setWaybill(result)
          // 存储基础信息留作对比手机号码默认选择寄件收件人
          this.storageBasicInfo = result
          // 下单新加参数 当前接口返回
          this.formData.userCode = result.customerCode || ''
          this.formData.userName = result.customerName || ''
          this.orderSourceName = result.orderSourceName || ''
          // if (data.waybillNo || this.keywordList.length) {
          //   this.changeSecondType(this.formData.secondTypeId)
          // }
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 180天数据时效数据
    async getPrescription(waybillNo = '') {
      console.log('222222222222222');
      const { data, code, msg } = await this.COM_HTTP.getSecondType({
        id: this.formData.firstTypeId,
        waybillNo: waybillNo || this.formData.waybillNo,
        historyType: this.isAll ? 2 : 1
      })
      if (code === RESPONSE_CODE.SUCCESS) {
        const { currentDuration, estimateDuration, transportationStatus, isPrescription } = data || {}
        this.prescriptionData = { currentDuration, estimateDuration, transportationStatus, isPrescription }
        this.$emit('prescriptionData', this.prescriptionData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 根据手机号码查询订单信息
    async queryOrderPhone() {
      const { orderId, customerPhone } = this.formData
      if (!(this.isRushTake && !orderId && customerPhone && this.phoneExp(customerPhone))) return
      try {
        const { code, data } = await RecordSheet.queryOrderPhone({ phone: customerPhone })
        if (code === RESPONSE_CODE.SUCCESS) {
          const { id } = data
          this.formData.orderId = id || ''
          id && this.$refs['form'].validateField('orderId')
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 请求是否为总部vip组
    async requestIsHqVip() {
      try {
        const { data } = await RecordSheet.reqIsHQVIP()
        this.hqVip = data
        // const value = data && this.formData.memberType === 1
        // if (value) {
        //   this.formData.groupType = 4
        //   this.handleChangeGroupType()
        // }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 转单选中判断是否是vip工单组
     * 为总部vip时data为true   groupType默认选中4  其他禁用
     */
    judgmentVip() {
      if (this.hqVip && this.formData.memberType === 1) {
        this.formData.groupType = 4
        this.handleChangeGroupType()
      }
    },
    changeOpinion() {
      this.isOpinionChange = true
    },
    /**
     * 客户属性
     */
    customerTypeInput() {
      this.$refs['form'].validateField('customerType')
    },
    // 获取单号是否为集运仓件
    async getConsolidation(val) {
      const reg = /^([JU]T|55)\d{13}$|^\d{13}$/
      if (reg.test(val)) {
        RecordSheet.reqConsolidation(val).then(({ data }) => {
          this.isConsolidation = data
        })
      }
    },
    // 异常客服编号提示
    async getCustomerExc(waybillNo) {
      this.COM_HTTP.getCustomerExc(waybillNo).then(({ data }) => {
        this.customerExcList = { ...data }
      })
    },
    // 问题描述校验
    problemDescriptionValidate(rule, value, callback) {
      const str = this.formData.problemDescription
      // this.formData.labelList?.forEach(item => {
      //   str = str.replace(item, '')
      // })
      if (!str) {
        callback(new Error(this.$lang('请输入')))
      } else {
        // this.formData.problemDescription = str
        callback()
      }
    }
  },
  computed: {
    ...mapGetters({
      imStorage: 'imStorage'
    }),
    // 平台催单
    isProject() {
      return this.formData.isProject
    },
    isHqVip() {
      return this.memberType === 1 && this.hqVip
    },
    // 是否禁用重发取件码按钮
    isDisabledResend() {
      return this.formData.waybillNo && this.waybillExist && this.keywordList.length !== 0
    },
    // 判断大屏
    isMax() {
      return this.screenWidth > 1500
    },
    // 工单类型是否为下单 （为下单需要收件人地址为非必填）
    isDisabledAddress() {
      return this.formData.secondTypeName === '下单' || this.formData.firstTypeName === '咨询'
    },
    isPlaceOrder() {
      return this.formData.secondTypeName === '下单'
    },
    // 处理模式禁用 => 运单不存在 || 没有运单号 || 二级类型为无转单对象
    modeDisabled() {
      // 当为问题件时默认可以转单，不用走其他逻辑
      if (this.isProblemType === 1) return false;
      // 当接口返回是bs 单号状态  默认走bs逻辑
      if (this.formData.bsType && this.immortalTrailList.length !== 0) return false
      // 是否是订单查询
      if (this.isRushTake) return false
      // 忽略物流轨迹扫描网点为空和问题件扫描
      const filterTrackingList = this.keywordList?.filter((item) => item.scanNetworkName && !['问题件扫描'].includes(item.scanTypeName));
      // 取最新一条物流轨迹
      const firstTracking = filterTrackingList[0] || {};
      // 二级类型配置转单责任方为签收网点，且最新物流轨迹扫描类型不为“出库扫描”，“入库扫描”，“签收扫描”时禁用转单
      const isDisabled = this.transferOrderOwner === 6 && !['出库扫描', '入库扫描', '快件签收'].includes(firstTracking.scanTypeName);
      // 二级类型配置转单责任方为超时效转单，且运单状态为默认关闭时turnSingleFlag
      const turnSingleFlag = this.transferOrderOwner === 8 && this.defaultGroup === 1;
      // 无单转单
      if (this.ifTransferOrder && this.addressReqNetwork) return false
      return (!this.waybillExist && !this.pickUpNetworkName) || !this.formData.waybillNo || this.transferOrderOwner === 4 || isDisabled || turnSingleFlag || this.netAbmWaybillDisable
    },
    // 是否为总部
    isHQ() {
      return this.user.networkType === CONST_TYPE['NT_HEADQUARTERS']
    },
    // 是否是网点
    isNet() {
      return this.user.networkType === CONST_TYPE['NT_FIRST_LEVEL']
    },
    // 是否是中心
    isCenter() {
      return this.user.networkType === CONST_TYPE['NT_CENTER']
    },
    // 是否为转单
    isTurn() {
      return this.formData.processingMode === 2
    },
    // 是否为催单（催单只能修改处理意见）
    isReminder() {
      return [REMINDER_MODE_MAP.NOT_HANDLE, REMINDER_MODE_MAP.REMINDER].includes(this.formData.reminderMode)
    },
    // 是否为暂不处理 / 催单 / 升级
    isUpgrade() {
      return this.isReminder || ([7, 8].includes(this.defaultGroup) && this.formData.reminderMode === REMINDER_MODE_MAP.UPGRADE)
    },
    networkOptions() {
      const item = this.networkGroup.find(o => o.groupType === this.formData.groupType) || {}
      return item.networks || []
    },
    // 百世录单判断条件 是否是百世
    isBsType() {
      return this.formData.bsType && this.defaultGroup === 9
    },
    // 催取件
    isRushTake({ formData }) {
      return this.formData.secondTypeCode === '2008'
    },
    // 是否转单
    ifTransferOrder() {
      const { firstTypeCode = '', secondTypeCode = '' } = this.formData
      return firstTypeCode && firstTypeCode === '20' && secondTypeCode && secondTypeCode === '2012'
    },
    // 二级类型是否为其他
    isOtherType() {
      return this.formData.secondTypeCode === '2006'
    },
    // 问题描述标签展示
    problemDescriptionLabel() {
      return this.descriptionList.length && (this.isOtherType || this.isVisit)
    },
    option() {
      const that = this
      const waybillNo = this.formData.waybillNo
      return {
        emptyBtn: false,
        group: [
          {
            label: '基本信息', //  @wait (附件大小不超出3M，支持格式PNG/JPG/GIF/ZIP)
            prop: 'baceData',
            column: [
              {
                label: '运单号',
                prop: 'waybillNo',
                placeholder: '请输入',
                isSuccesslabel: this.orderSourceName,
                valueWidth: '160px',
                fetchSuggestions: true, // 新增
                // rules: [RULES.required],
                rules: [{ validator: that.validatorWaybill, trigger: ['change', 'blur'] }],
                disabled: that.waybillVisible || that.isRushTake, // 催取件状态禁用
                maxlength: 15,
                block: !!this.formData.isProject,
                blur: ({ value }) => {
                  if (value === '') {
                    that.storageType = true
                    that.orderSourceName = ''
                  }
                },
                change: ({ value }) => {
                  if (value === '') {
                    that.storageType = true
                    that.secondTypeList = that.secondTypeList.map(o => {
                      o.isDisabled = false
                      return o
                    })
                  }
                  // that.getConsolidation(value)
                  // ----------------
                  that.waybillExist = false
                  that.formData.isProject = null
                  that.customerExcList = {}
                  that.debounceFn(value)
                  // 异常客服编号提示
                  // const rex = /^([JU]T|55)\d{13}$|^\d{13}$/
                  // if (rex.test(value)) {
                  //   that.getCustomerExc(value)
                  //   that.$refs.abnomalTip.getNetWaybill(value)
                  // }
                }
              },
              {
                label: '',
                prop: 'waybillNoTip',
                slot: true
              },
              // 异常客服编号提示
              {
                label: '',
                prop: 'waybillNoTipTwo',
                slot: true
              },
              {
                label: '来电号码',
                prop: 'customerPhone',
                isSuccesslabel: this.customerAddress,
                display: !this.formData.isProject, // TODO
                span: 24,
                // 判断是否是55百世单号 不去校验
                rules: [
                  RULES.required, {
                    validator(rule, value, callback) {
                      const regExp = /(^1[3-9]\d{9}$)|(^[0｜2-9]\d{5,14}$)/
                      const regExp2 = /^(\d)\1{5,14}$/
                      const typeBs = waybillNo && waybillNo.startsWith('55')
                      if (value && !typeBs && (!regExp.test(value) || regExp2.test(value))) {
                        console.log(this.customerTagList);
                        that.customerTagList = []
                        callback(new Error(that.$lang('请输入正确的联系号码')))
                      } else {
                        // 运单号校验正确 去记录状态查询权限
                        // if (that.waybillType && this.onState) {
                        //   that.getCheckStatus()
                        // }
                        value && that.getCustomerAddress(value)
                        value && that.getQueryByPhone(value)
                        // 根据手机号码获取订单信息
                        that.queryOrder()
                        callback()
                      }
                    },
                    trigger: ['change', 'blur']
                  }
                ]
              },
              {
                label: '来访对象',
                prop: 'customerName',
                display: !this.formData.isProject, // TODO
                disabled: that.isUpgrade,
                placeholder: '请输入',
                maxlength: 20,
                right: '10px',
                valueWidth: '120px',
                rules: [RULES.required],
                change: ({ value }) => {
                  const sex = that.formData.customerSex === 1 ? '先生' : '女士'
                  if (value) {
                    that.formData.callBackName = value + sex
                    that.$refs.form.validateField('callBackName')
                  } else {
                    that.formData.callBackName = ''
                  }
                }
              },
              {
                label: '',
                prop: 'customerSex',
                display: !this.formData.isProject, // TODO
                right: '10px'
              },
              {
                label: '',
                prop: 'customerType',
                display: !this.formData.isProject, // TODO
                right: '0',
                rules: [RULES.required]
              },
              {
                label: '收件人地址',
                prop: 'receiverAreaId',
                rules: [{ required: !that.isDisabledAddress && !that.isUpgrade && !this.formData.isProject, message: that.$lang('请选择省市区'), trigger: ['blur', 'change'] }], // TODO
                right: '10px'
              },
              {
                label: '',
                prop: 'receiverDetailedAddress',
                disabled: (that.isUpgrade || that.isDisabledAddress) && !this.formData.isProject,
                rules: [{ required: !that.isDisabledAddress && !that.isUpgrade && !this.formData.isProject, message: that.$lang('请输入详细地址'), trigger: ['blur', 'change'] }],
                placeholder: '请输入详细地址'
              }
            ]
          },
          {
            label: '问题信息',
            prop: 'secondType',
            // groupSlot: true,
            column: [
              {
                label: '一级问题类型',
                prop: 'firstType',
                rules: this.isProject ? [] : [RULES.required],
                span: 24,
                height: 'auto',
                bottom: '10px'
              },
              {
                label: '二级问题类型',
                prop: 'secondTypeId',
                rules: this.isProject ? [] : [RULES.required],
                span: 24,
                height: 'auto',
                bottom: '10px'
              },
              {
                prop: 'orderForm',
                display: that.isPlaceOrder,
                height: 'auto',
                bottom: '0'
              },
              {
                label: '客户地址',
                prop: 'typeReceiverProvinceName',
                display: this.isOtherType || this.isRushTake,
                disabled: that.isUpgrade,
                rules: (!that.isUpgrade && !this.isRushTake && !this.isOtherType) || that.formData.typeReceiverDetailedAddress ? [RULES.required] : []
              },
              {
                label: '',
                prop: 'typeReceiverDetailedAddress',
                display: this.isOtherType || this.isRushTake,
                disabled: that.isUpgrade,
                rules: (!that.isUpgrade && !this.isRushTake && !this.isOtherType) || that.formData.typeReceiverProvinceName ? [RULES.required] : [],
                placeholder: '请输入详细地址',
                blur({ value }) {
                  that.typeReceiver.details = value
                  that.queryDataAddress('typeReceiver')
                }
              },
              {
                label: '订单号',
                prop: 'orderId',
                display: that.isRushTake,
                changeRules: true,
                isRightLabel: that.orderTip,
                isBottomLabel: that.cancelExplain,
                span: 24,
                maxlength: 19,
                placeholder: '请输入订单号',
                rules: [{ validator: that.orderExp,
                  trigger: ['change', 'blur'] }],
                change({ value }) {
                  // that.debounceOrder(value)
                  !value && that.$bus.$emit('getOrderId', '')
                }
              },
              // {
              //   label: '紧急程度',
              //   prop: 'emergencyLevel',
              //   rules: [RULES.requiredOptions],
              //   disabled: that.isUpgrade,
              //   clearable: false,
              //   valueDefault: 2,
              //   dicData: this.emergencyCict
              // },
              {
                label: '会员',
                prop: 'memberType',
                rules: [RULES.requiredOptions],
                disabled: true,
                valueDefault: 2,
                dicData: this.memberTypeDict,
                span: 24
              },
              {
                label: '客户地址',
                prop: 'address',
                rules: [{ required: true, message: that.$lang('请选择省市区'), trigger: ['blur', 'change'] }],
                right: '10px',
                display: that.ifTransferOrder
              },
              {
                label: '',
                prop: 'details',
                rules: [{ required: true, message: that.$lang('请输入详细地址'), trigger: ['blur', 'change'] }],
                placeholder: '请输入详细地址',
                clearable: true,
                display: that.ifTransferOrder,
                change({ value }) {
                  that.customerAddressData.details = value
                  that.addressReqNetwork = null
                  that.queryDataAddress()
                }
              },
              {
                label: '问题描述',
                prop: 'problemDescription',
                placeholder: '请输入',
                type: 'textarea',
                minRows: that.isMax ? 3 : 2,
                maxlength: 500,
                flex: true,
                display: !this.formData.isProject,
                disabled: that.isUpgrade,
                rules: [RULES.required, { validator: this.handlingOpinionsValidate('problemDescriptionStr'), trigger: ['blur', 'change'] }, { validator: this.problemDescriptionValidate, trigger: ['blur', 'change'] }],
                showWordLimit: true,
                span: 24,
                change(obj) {
                  that.isChangeOpinions = true
                }
              }
            ]
          },
          {
            label: '处理',
            prop: 'handle',
            style: { marginBottom: '0' },
            column: [
              {
                label: '',
                prop: 'mode',
                block: true,
                bottom: '5px',
                span: 4
              },
              {
                label: '',
                prop: 'groupType',
                block: true,
                bottom: '5px',
                height: 'auto',
                display: !this.isUpgrade && this.isTurn,
                span: 8
              },
              {
                label: '催单原因',
                prop: 'reminderReason',
                type: 'select',
                clearable: false,
                rules: [RULES.required],
                dicData: this.reasonOptions,
                display: this.formData.reminderMode === REMINDER_MODE_MAP.REMINDER,
                span: 24
              },
              {
                label: '',
                prop: 'networkId',
                span: 24,
                bottom: that.isMax ? '40px' : '20px',
                rules: [RULES.required],
                display: (this.isTurn || this.formData.reminderMode === REMINDER_MODE_MAP.UPGRADE) && !this.formData.isProject
              },
              {
                label: '回电对象',
                prop: 'callBackName',
                rules: [RULES.required],
                placeholder: '请输入',
                maxlength: 15,
                // 处理方式为关闭或为下单的时候许隐藏回电号码，回电对象
                display: (this.isTurn || this.isUpgrade) && !this.formData.isProject
              },
              {
                label: '回电号码',
                prop: 'callBackPhone',
                placeholder: '请输入',
                changeRules: true,
                rules: [RULES.required, { validator: that.callBackPhone,
                  trigger: ['change', 'blur'] }],
                maxlength: 15,
                // 处理方式为关闭或为下单的时候许隐藏回电号码，回电对象
                display: (this.isTurn || this.isUpgrade) && !this.formData.isProject,
                change: ({ value }) => {
                  value = value.replace(/\s/g, '')
                  that.formData.callBackPhone = value
                  that.callBackPhoneExp(value) && that.setTheLog('3')
                }
              },
              {
                label: '处理意见',
                prop: 'handlingOpinions',
                placeholder: '请输入',
                type: 'textarea',
                minRows: that.isMax ? 3 : 2,
                span: 24,
                autosize: true,
                maxlength: 500,
                // 只有当处理模式为关闭或催单时才展示
                display: this.formData.processingMode === 1 || this.isUpgrade,
                rules: [RULES.required, { validator: this.handlingOpinionsValidate(), trigger: ['blur', 'change'] }],
                showWordLimit: true
              }
            ]
          }
        ]
      }
    },
    // 异常运单
    netAbmWaybillDisable() {
      const { disableWorkOrder, allowWorkorderList = [] } = this.$refs.abnomalTip.netAbmWaybill
      const { firstTypeId, secondTypeId } = this.formData
      if (disableWorkOrder !== 2) return false// 非限制转单
      const searchinfo = allowWorkorderList?.filter((item) => {
        return item.allowWorkorderTypeId === firstTypeId && item.id === secondTypeId
      }) || []
      if (!searchinfo.length) {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    // 不在 在线客服/录单 不请求接口
    if (this.$route.name === 'imOnline' || this.$route.name === 'callCenter' || this.$route.name === 'tiktokTable') {
      this.getFirstType()
      !this.noPhoneBar && this.getServiceStaff()
    }
  }
}
</script>

<style lang="scss">
.record-sheet-form {
  // 百世按钮
  .bs-radio {
    margin-right: 0px;
    height: 24px;
    display: flex;
    align-items: center;
  }
  .bs-service {
    .group-content {
      > :nth-child(1) {
        padding-right: 0px;
      }
      > :nth-child(2) {
        // padding-right: 5px;
      }
    }
  }
  .project-process-question {
    display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;
    .q-list {
      // width: 80px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      border: 1px solid #dddddd;
      border-radius: 4px;
      margin: 0 10px 10px 0;
      box-sizing: border-box;
      color: #999999;
      @include border-color('lighter');
      @include text-color('routine');
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      word-break: break-all;
      text-overflow: ellipsis;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      .el-icon-success {
        position: absolute;
        right: -4px;
        top: -6px;
        z-index: 100;
        overflow: none;
        font-size: 12px;
      }
    }
    .active {
      // @include base-bg-color-1();
      // border: 1px solid rgba(45,124,255,0.5);
      @include base-color('clr');
      // @include base-border-color-5();
    }
  }
  .avue-form__item--4 {
    .el-form-item__content {
      width: 200px;
    }
  }
  .customer-num {
    color: #ffffff;
    @include bg-color('brand');
    border-radius: 100%;
    /* position: absolute; */
    /* left: 160px; */
    /* top: 5px; */
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    /* padding: 5px; */
    display: inline-block
  }
  .custom-province .cp-modal {
    z-index: 99999;
  }

  .line-radio {
    margin-top: 10px;
  }
}

.record-sheet-form {
  width: 550px;
  .el-radio-group {
    display: inline-block;
  }
  .el-radio__label {
    padding-left: 4px;
    font-size: 12px;
  }
  .search-btn {
    position: absolute;
    top: 0;
    // right: 10px;
    left:115px;
    font-size: 12px;
    cursor: pointer;
    // color: #2d7cff;
    color: $-color-brand;
  }
  .type-wrap {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    .no-data {
      text-align: center;
      color: #999;
    }
  }
}
@media screen and (min-width: 1500px) {
  #gateway .record-sheet-form {
    .group-item:not(.last-item) {
      margin-bottom: 40px;
    }
    .form-item {
      height: 32px;
      .label {
        line-height: 32px;
      }
      .input-box {
        min-height: 32px;
      }
      .el-input input {
        height: 32px;
        line-height: 32px;
      }
    }
    .search-btn {
      line-height: 32px;
    }
    .el-input .el-input__icon {
      line-height: 32px;
    }
    .el-input {
      height: 32px;
    }
    .line-radio {
      margin-top: 20px;
      margin-bottom: 14px;
    }
    .el-radio__label {
      line-height: 32px;
    }
  }
}

.softphone {
  padding: 3px 20px;
  box-sizing: border-box;
}
</style>
<style lang="scss" scoped>
.leftform-customer-type {
  position: relative;
  .customer-type {
    position: absolute;
    top:-6px;
    font-weight: bolder;
    font-size: 16px;
    white-space: nowrap;
    height: 36px;
  }
}
</style>
